import avatar1 from '../styles/images/avatars/Люди/Number=1.png'
import avatar2 from '../styles/images/avatars/Люди/Number=2.png'
import avatar3 from '../styles/images/avatars/Люди/Number=3.png'
import avatar4 from '../styles/images/avatars/Люди/Number=4.png'
import avatar5 from '../styles/images/avatars/Люди/Number=5.png'
import avatar6 from '../styles/images/avatars/Люди/Number=6.png'
import avatar7 from '../styles/images/avatars/Люди/Number=7.png'
import avatar8 from '../styles/images/avatars/Люди/Number=8.png'
import avatar9 from '../styles/images/avatars/Люди/Number=9.png'
import avatar10 from '../styles/images/avatars/Люди/Number=10.png'
import avatar11 from '../styles/images/avatars/Люди/Number=11.png'
import avatar12 from '../styles/images/avatars/Люди/Number=12.png'
import avatar13 from '../styles/images/avatars/Люди/Number=13.png'
import avatar14 from '../styles/images/avatars/Люди/Number=14.png'
import avatar15 from '../styles/images/avatars/Люди/Number=15.png'
import avatar16 from '../styles/images/avatars/Люди/Number=16.png'
import avatar17 from '../styles/images/avatars/Люди/Number=17.png'
import avatar18 from '../styles/images/avatars/Люди/Number=18.png'
import avatar19 from '../styles/images/avatars/Люди/Number=19.png'
import avatar20 from '../styles/images/avatars/Люди/Number=20.png'
import avatar21 from '../styles/images/avatars/Люди/Number=21.png'
import avatar22 from '../styles/images/avatars/Люди/Number=22.png'
import avatar23 from '../styles/images/avatars/Люди/Number=23.png'
import avatar24 from '../styles/images/avatars/Люди/Number=24.png'
import avatar25 from '../styles/images/avatars/Люди/Number=25.png'
import avatar26 from '../styles/images/avatars/Люди/Number=26.png'
import avatar27 from '../styles/images/avatars/Люди/Number=27.png'
import avatar28 from '../styles/images/avatars/Люди/Number=28.png'
import avatar29 from '../styles/images/avatars/Люди/Number=29.png'
import avatar30 from '../styles/images/avatars/Люди/Number=30.png'
import avatar31 from '../styles/images/avatars/Люди/Number=31.png'
import avatar32 from '../styles/images/avatars/Люди/Number=32.png'
import avatar33 from '../styles/images/avatars/Люди/Number=33.png'
import avatar34 from '../styles/images/avatars/Люди/Number=34.png'
import avatar35 from '../styles/images/avatars/Люди/Number=35.png'
import avatar36 from '../styles/images/avatars/Люди/Number=36.png'
import avatar37 from '../styles/images/avatars/Люди/Number=37.png'
import avatar38 from '../styles/images/avatars/Люди/Number=38.png'
import avatar39 from '../styles/images/avatars/Люди/Number=39.png'
import avatar40 from '../styles/images/avatars/Люди/Number=40.png'
import avatar41 from '../styles/images/avatars/Люди/Number=41.png'
import avatar42 from '../styles/images/avatars/Люди/Number=42.png'
import avatar43 from '../styles/images/avatars/Люди/Number=43.png'
import avatar44 from '../styles/images/avatars/Люди/Number=44.png'
import avatar45 from '../styles/images/avatars/Люди/Number=45.png'
import avatar46 from '../styles/images/avatars/Люди/Number=46.png'
import avatar47 from '../styles/images/avatars/Люди/Number=47.png'
import avatar48 from '../styles/images/avatars/Люди/Number=48.png'
import avatar49 from '../styles/images/avatars/Люди/Number=49.png'
import avatar50 from '../styles/images/avatars/Люди/Number=50.png'
import avatar51 from '../styles/images/avatars/Люди/Number=51.png'
import avatar52 from '../styles/images/avatars/Люди/Number=52.png'
import avatar53 from '../styles/images/avatars/Люди/Number=53.png'
import avatar54 from '../styles/images/avatars/Люди/Number=54.png'
import avatar55 from '../styles/images/avatars/Люди/Number=55.png'
import avatar56 from '../styles/images/avatars/Люди/Number=56.png'
import avatar57 from '../styles/images/avatars/Люди/Number=57.png'
import avatar58 from '../styles/images/avatars/Люди/Number=58.png'
import avatar59 from '../styles/images/avatars/Люди/Number=59.png'
import avatar60 from '../styles/images/avatars/Люди/Number=60.png'
import avatar61 from '../styles/images/avatars/Люди/Number=61.png'
import avatar62 from '../styles/images/avatars/Люди/Number=62.png'
import avatar63 from '../styles/images/avatars/Люди/Number=63.png'
import avatar64 from '../styles/images/avatars/Люди/Number=64.png'
import avatar65 from '../styles/images/avatars/Люди/Number=65.png'
import avatar66 from '../styles/images/avatars/Люди/Number=66.png'
import avatar67 from '../styles/images/avatars/Люди/Number=67.png'
import avatar68 from '../styles/images/avatars/Люди/Number=68.png'
import avatar69 from '../styles/images/avatars/Люди/Number=69.png'
import avatar70 from '../styles/images/avatars/Люди/Number=70.png'
import avatar71 from '../styles/images/avatars/Люди/Number=71.png'
import avatar72 from '../styles/images/avatars/Люди/Number=72.png'
import avatar73 from '../styles/images/avatars/Люди/Number=73.png'
import avatar74 from '../styles/images/avatars/Люди/Number=74.png'
import avatar75 from '../styles/images/avatars/Люди/Number=75.png'
import avatar76 from '../styles/images/avatars/Люди/Number=76.png'
import avatar77 from '../styles/images/avatars/Люди/Number=77.png'
import avatar78 from '../styles/images/avatars/Люди/Number=78.png'
import avatar79 from '../styles/images/avatars/Люди/Number=79.png'
import avatar80 from '../styles/images/avatars/Люди/Number=80.png'
import avatar81 from '../styles/images/avatars/Люди/Number=81.png'
import avatar82 from '../styles/images/avatars/Люди/Number=82.png'
import avatar83 from '../styles/images/avatars/Люди/Number=83.png'
import avatar84 from '../styles/images/avatars/Люди/Number=84.png'
import avatar85 from '../styles/images/avatars/Люди/Number=85.png'
import avatar86 from '../styles/images/avatars/Люди/Number=86.png'
import avatar87 from '../styles/images/avatars/Люди/Number=87.png'
import avatar88 from '../styles/images/avatars/Люди/Number=88.png'
import avatar89 from '../styles/images/avatars/Люди/Number=89.png'
import avatar90 from '../styles/images/avatars/Люди/Number=90.png'
import avatar91 from '../styles/images/avatars/Люди/Number=91.png'
import avatar92 from '../styles/images/avatars/Люди/Number=92.png'
import avatar93 from '../styles/images/avatars/Люди/Number=93.png'
import avatar94 from '../styles/images/avatars/Люди/Number=94.png'
import avatar95 from '../styles/images/avatars/Люди/Number=95.png'
import avatar96 from '../styles/images/avatars/Люди/Number=96.png'
import avatar97 from '../styles/images/avatars/Люди/Number=97.png'
import avatar98 from '../styles/images/avatars/Люди/Number=98.png'
import avatar99 from '../styles/images/avatars/Люди/Number=99.png'
import avatar100 from '../styles/images/avatars/Люди/Number=100.png'
import avatar101 from '../styles/images/avatars/Люди/Number=101.png'
import avatar102 from '../styles/images/avatars/Люди/Number=102.png'
import avatar103 from '../styles/images/avatars/Люди/Number=103.png'
import avatar104 from '../styles/images/avatars/Люди/Number=104.png'
import avatar105 from '../styles/images/avatars/Люди/Number=105.png'
import avatar106 from '../styles/images/avatars/Люди/Number=106.png'
import avatar107 from '../styles/images/avatars/Люди/Number=107.png'
import avatar108 from '../styles/images/avatars/Люди/Number=108.png'
import avatar109 from '../styles/images/avatars/Люди/Number=109.png'
import avatar110 from '../styles/images/avatars/Люди/Number=110.png'
import avatar111 from '../styles/images/avatars/Люди/Number=111.png'
import avatar112 from '../styles/images/avatars/Люди/Number=112.png'
import avatar113 from '../styles/images/avatars/Люди/Number=113.png'
import avatar114 from '../styles/images/avatars/Люди/Number=114.png'
import avatar115 from '../styles/images/avatars/Люди/Number=115.png'
import avatar116 from '../styles/images/avatars/Люди/Number=116.png'

export const DEFAULT_OPERATOR_AVATAR_ID = 1

/** Fixed local catalog. API values select an item and never become a URL. */
export const OPERATOR_AVATARS: ReadonlyArray<{id: number; url: string}> = [
    {id: 1, url: avatar1},
    {id: 2, url: avatar2},
    {id: 3, url: avatar3},
    {id: 4, url: avatar4},
    {id: 5, url: avatar5},
    {id: 6, url: avatar6},
    {id: 7, url: avatar7},
    {id: 8, url: avatar8},
    {id: 9, url: avatar9},
    {id: 10, url: avatar10},
    {id: 11, url: avatar11},
    {id: 12, url: avatar12},
    {id: 13, url: avatar13},
    {id: 14, url: avatar14},
    {id: 15, url: avatar15},
    {id: 16, url: avatar16},
    {id: 17, url: avatar17},
    {id: 18, url: avatar18},
    {id: 19, url: avatar19},
    {id: 20, url: avatar20},
    {id: 21, url: avatar21},
    {id: 22, url: avatar22},
    {id: 23, url: avatar23},
    {id: 24, url: avatar24},
    {id: 25, url: avatar25},
    {id: 26, url: avatar26},
    {id: 27, url: avatar27},
    {id: 28, url: avatar28},
    {id: 29, url: avatar29},
    {id: 30, url: avatar30},
    {id: 31, url: avatar31},
    {id: 32, url: avatar32},
    {id: 33, url: avatar33},
    {id: 34, url: avatar34},
    {id: 35, url: avatar35},
    {id: 36, url: avatar36},
    {id: 37, url: avatar37},
    {id: 38, url: avatar38},
    {id: 39, url: avatar39},
    {id: 40, url: avatar40},
    {id: 41, url: avatar41},
    {id: 42, url: avatar42},
    {id: 43, url: avatar43},
    {id: 44, url: avatar44},
    {id: 45, url: avatar45},
    {id: 46, url: avatar46},
    {id: 47, url: avatar47},
    {id: 48, url: avatar48},
    {id: 49, url: avatar49},
    {id: 50, url: avatar50},
    {id: 51, url: avatar51},
    {id: 52, url: avatar52},
    {id: 53, url: avatar53},
    {id: 54, url: avatar54},
    {id: 55, url: avatar55},
    {id: 56, url: avatar56},
    {id: 57, url: avatar57},
    {id: 58, url: avatar58},
    {id: 59, url: avatar59},
    {id: 60, url: avatar60},
    {id: 61, url: avatar61},
    {id: 62, url: avatar62},
    {id: 63, url: avatar63},
    {id: 64, url: avatar64},
    {id: 65, url: avatar65},
    {id: 66, url: avatar66},
    {id: 67, url: avatar67},
    {id: 68, url: avatar68},
    {id: 69, url: avatar69},
    {id: 70, url: avatar70},
    {id: 71, url: avatar71},
    {id: 72, url: avatar72},
    {id: 73, url: avatar73},
    {id: 74, url: avatar74},
    {id: 75, url: avatar75},
    {id: 76, url: avatar76},
    {id: 77, url: avatar77},
    {id: 78, url: avatar78},
    {id: 79, url: avatar79},
    {id: 80, url: avatar80},
    {id: 81, url: avatar81},
    {id: 82, url: avatar82},
    {id: 83, url: avatar83},
    {id: 84, url: avatar84},
    {id: 85, url: avatar85},
    {id: 86, url: avatar86},
    {id: 87, url: avatar87},
    {id: 88, url: avatar88},
    {id: 89, url: avatar89},
    {id: 90, url: avatar90},
    {id: 91, url: avatar91},
    {id: 92, url: avatar92},
    {id: 93, url: avatar93},
    {id: 94, url: avatar94},
    {id: 95, url: avatar95},
    {id: 96, url: avatar96},
    {id: 97, url: avatar97},
    {id: 98, url: avatar98},
    {id: 99, url: avatar99},
    {id: 100, url: avatar100},
    {id: 101, url: avatar101},
    {id: 102, url: avatar102},
    {id: 103, url: avatar103},
    {id: 104, url: avatar104},
    {id: 105, url: avatar105},
    {id: 106, url: avatar106},
    {id: 107, url: avatar107},
    {id: 108, url: avatar108},
    {id: 109, url: avatar109},
    {id: 110, url: avatar110},
    {id: 111, url: avatar111},
    {id: 112, url: avatar112},
    {id: 113, url: avatar113},
    {id: 114, url: avatar114},
    {id: 115, url: avatar115},
    {id: 116, url: avatar116},
]

export const normalizeOperatorAvatarID = (avatarID?: number | null): number => typeof avatarID === 'number'
    && Number.isSafeInteger(avatarID) && avatarID >= 1
    ? avatarID : DEFAULT_OPERATOR_AVATAR_ID

export const getSafeOperatorAvatarUrl = (avatarUrl?: string | null): string | undefined => {
    if (typeof avatarUrl !== 'string' || !avatarUrl || avatarUrl.length > 4096 || /[\x00-\x1f]/.test(avatarUrl)) return
    try {
        const base = typeof window === 'undefined' ? 'https://crm.invalid' : window.location.origin
        const url = new URL(avatarUrl, base)
        if (!['http:', 'https:'].includes(url.protocol)) return
        if (!avatarUrl.startsWith('/') && !/^https?:\/\//i.test(avatarUrl)) return
        return avatarUrl
    } catch { return }
}

export const getOperatorAvatarUrl = (avatarID?: number | null, avatarUrl?: string | null): string =>
    getSafeOperatorAvatarUrl(avatarUrl) || OPERATOR_AVATARS[normalizeOperatorAvatarID(avatarID) - 1]?.url || OPERATOR_AVATARS[0].url

export const getAvatarCatalogItemUrl = (item: {id: number; url: string | null; builtinID: number | null}) =>
    getOperatorAvatarUrl(item.builtinID || item.id, item.url)

